export default __webpack_public_path__ + "static/media/Roanoke.6a7a6b7a.PNG";